/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
module.exports = {
  initialize(gridOptions) {
    $('#pagination').exists();
    this._gridOptions = gridOptions;
    return this;
  },

  _paginationTemplate: `\
    <div class="row" id="search-results-sortbar">
    <div class="small-24 columns">
    <ul class="ais-pagination pagination top-buffer">
    <% if(currentPageNumber != 0) { %>
    <li><a aria-label="<%= I18n.t("first") %>" data-first>«</a></li>
    <li><a aria-label="<%= I18n.t("previous") %>" data-prev>‹</a></li>
    <% } %>
    <% _(pageNumbers).each(function(pageNumber){ %>
    <li class="<%= currentPageNumber == pageNumber ? "current" : "" %> "><a class="ais-pagination--link" aria-label="<%= pageNumber + 1 %>" data-go-to-page data-page-number="<%= pageNumber %>"><%= pageNumber + 1 %></a></li>
    <% }) %>
    <% if(currentPageNumber + 1 != pagesCount) { %>
    <li><a data-next aria-label="<%= I18n.t("next") %>" data-next>›</a></li>
    <li><a aria-label="<%= I18n.t("last") %>" data-last>»</a></li>
    <% } %>
    </ul>
    </div>
    </div>`,

  _preparePaginationPages() {
    const pagesCount = this._gridOptions.api.paginationGetTotalPages();
    const currentPageNumber = this._gridOptions.api.paginationGetCurrentPage();
    const padding = 3;
    let pageNumbers = [currentPageNumber];

    _(padding).times(function(index) {
      index += 1;
      const nextPage = currentPageNumber + index;
      const prevPage = currentPageNumber - index;
      if (nextPage < pagesCount) { pageNumbers.push(nextPage); }
      if (prevPage >= 0) { return pageNumbers.push(prevPage); }
    });

    const missingPagesCount = ((padding * 2) + 1) - pageNumbers.length;
    pageNumbers = _.sortBy(pageNumbers);

    _(missingPagesCount).times(function() {
      const nextPage = _.last(pageNumbers) + 1;
      const prevPage = _.first(pageNumbers) - 1;
      if (nextPage < pagesCount) { pageNumbers.push(nextPage); }
      if (prevPage >= 0) { return pageNumbers.unshift(prevPage); }
    });

    return _.sortBy(pageNumbers);
  },

  initializePaginationListeners() {
    $('#pagination').exists().on('click', 'a[data-first]', () => this._gridOptions.api.paginationGoToFirstPage());
    $('#pagination').exists().on('click', 'a[data-prev]', () => this._gridOptions.api.paginationGoToPreviousPage());
    $('#pagination').exists().on('click', 'a[data-next]', () => this._gridOptions.api.paginationGoToNextPage());
    $('#pagination').exists().on('click', 'a[data-last]', () => this._gridOptions.api.paginationGoToLastPage());
    return $('#pagination').exists().on('click', 'a[data-go-to-page]', e => {
      const {
        pageNumber
      } = $(e.currentTarget).data();
      return this._gridOptions.api.paginationGoToPage(pageNumber);
    });
  },

  renderPagination() {
    const pageNumbers = this._preparePaginationPages();
    return $('#pagination').html(_.template(this._paginationTemplate)({currentPageNumber: this._gridOptions.api.paginationGetCurrentPage(), pageNumbers, pagesCount: this._gridOptions.api.paginationGetTotalPages()}));
  }
  };
